const { UserActionsBigQueryEvents } = require('./userActions');

const BigQueryEvents = {
    userActions: UserActionsBigQueryEvents
};

module.exports = {
    BigQueryEvents
};
